export const NAVIGATOR_ZOOM_SETTINGS = {
  min: 0.05,
  max: 2.5,
};
